import { render } from "./HomeDefault.vue?vue&type=template&id=49ab29d0&scoped=true"
import script from "./HomeDefault.vue?vue&type=script&lang=js"
export * from "./HomeDefault.vue?vue&type=script&lang=js"

import "./HomeDefault.vue?vue&type=style&index=0&id=49ab29d0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49ab29d0"]])

export default __exports__